import React from 'react';

function Guestbook() {
  return (
    <div className="guestbook">
      <div align="center">
        <p>
          <br />
          <br />
          <font size="+2" color="#7915bc">guestlist/communication</font>
          <br />
          <br />
          Thank you for your interest in Colorquilts!
        </p>
        <p>I'd love to hear from you -- any comments, questions...</p>
      </div>
      <div align="left">
        <p>
          If you fill out and submit the form below, I'll get the communication in my email, 
          and will try to answer back if I can.
        </p>
        <p>
          I maintain an email-ing list, and mail out an announcement a couple times a year. 
          If you think you're on the list already, or would like to be added, please indicate 
          it on the form. If you don't say anything about the mailing list, you'll automatically 
          be added.
        </p>
        <p>
          <strong>PLEASE NOTE:</strong> I respect your privacy, and do not share my mailing list 
          with anyone.
        </p>
      </div>
      <div align="center">
        {/* Note: We should replace this with a modern form solution */}
        <iframe 
          width="540" 
          height="509" 
          src="http://formsmarts.com/form/csc?mode=embed&lay=1" 
          scrolling="auto" 
          marginWidth="0" 
          marginHeight="0" 
          title="Contact Form"
          style={{ border: 'none', overflowX: 'hidden' }}
        >
          <a href="http://formsmarts.com/form/csc">Can't see the form? Click here</a>
        </iframe>
      </div>
    </div>
  );
}

export default Guestbook;
